<template>
  <customview ref="customview"></customview>
</template>
<script>
import customview from "@/components/common/customprint/customview";
export default {
  components: { customview },
  data() {
    return {
      data: {}
    }
  },
  mounted() {
  },
}
</script>